var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6671 0.833344H2.33374C1.41707 0.833344 0.675402 1.58334 0.675402 2.50001L0.667068 12.5C0.667068 13.4167 1.41707 14.1667 2.33374 14.1667H15.6671C16.5837 14.1667 17.3337 13.4167 17.3337 12.5V2.50001C17.3337 1.58334 16.5837 0.833344 15.6671 0.833344ZM15.3337 4.37501L9.44207 8.05834C9.1754 8.22501 8.8254 8.22501 8.55874 8.05834L2.66707 4.37501C2.58351 4.3281 2.51033 4.26473 2.45198 4.18872C2.39362 4.11272 2.35129 4.02566 2.32755 3.93282C2.30381 3.83998 2.29915 3.74329 2.31387 3.6486C2.32858 3.55391 2.36235 3.46319 2.41314 3.38193C2.46392 3.30067 2.53067 3.23056 2.60934 3.17584C2.68801 3.12112 2.77696 3.08294 2.87081 3.06359C2.96467 3.04425 3.06147 3.04415 3.15536 3.0633C3.24926 3.08245 3.33829 3.12045 3.41707 3.17501L9.0004 6.66668L14.5837 3.17501C14.6625 3.12045 14.7515 3.08245 14.8454 3.0633C14.9393 3.04415 15.0361 3.04425 15.13 3.06359C15.2238 3.08294 15.3128 3.12112 15.3915 3.17584C15.4701 3.23056 15.5369 3.30067 15.5877 3.38193C15.6385 3.46319 15.6722 3.55391 15.6869 3.6486C15.7016 3.74329 15.697 3.83998 15.6733 3.93282C15.6495 4.02566 15.6072 4.11272 15.5488 4.18872C15.4905 4.26473 15.4173 4.3281 15.3337 4.37501Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.db5099b99111b3e66448168a0183630a.svg";
export { ForwardRef as ReactComponent };